const footerLinks = {
  '观影导航': ['热播推荐', '专题合集', '热播榜单', '精彩预告', '焦点专题'],
  '帮助中心': ['常见问题', '播放教程', '投屏指南', '画质设置', '线路切换'],
  '关于我们': ['关于午马', '联系我们', '意见反馈', '商务合作', '版权声明'],
};

export default function Footer() {
  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    const target = document.querySelector(sectionId);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const sectionMap: Record<string, string> = {
    '热播推荐': '#cards',
    '专题合集': '#index',
    '热播榜单': '#ranking',
    '精彩预告': '#media',
    '焦点专题': '#carousel',
    '常见问题': '#faq',
    '关于午马': '#about',
    '联系我们': '#contact',
  };

  return (
    <footer id="footer" className="w-full bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-18">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center text-accent-400 text-xl">
                <i className="ri-movie-2-line"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">午马影院</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              高清不缓冲免费在线影院，即点即播无需注册。涵盖最新电影、热播剧集、人气综艺、经典动漫等海量资源，每日持续更新，流畅播放不卡顿。
            </p>
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 text-sm cursor-pointer hover:bg-primary-600 hover:text-background-50 transition-colors">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 text-sm cursor-pointer hover:bg-primary-600 hover:text-background-50 transition-colors">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 text-sm cursor-pointer hover:bg-primary-600 hover:text-background-50 transition-colors">
                <i className="ri-bilibili-line"></i>
              </span>
            </div>
          </div>

          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="font-heading text-sm font-bold text-background-100 mb-4">{category}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link}>
                    {sectionMap[link] ? (
                      <a
                        href={sectionMap[link]}
                        onClick={(e) => handleNav(e, sectionMap[link])}
                        className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer"
                      >
                        {link}
                      </a>
                    ) : (
                      <span className="text-sm text-background-500">{link}</span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; 2026 午马影院 wumacinema.com · 高清不缓冲免费在线看 · 本站内容仅供交流学习
            </p>
            <div className="flex items-center gap-4 text-xs text-background-500">
              <span>合作伙伴</span>
              <span className="text-background-700">——</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}